import React, {useState, useEffect} from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { requestForToken, onMessageListener } from './firebase';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { showLogoutModal, toggleAddProgrammePopup } from '../redux/reducers/view';
import { setRequestId, setResults, showTurnitinResults, turnitinEulaRequest, turnitinGenerateRequest, turnitinRequest } from '../redux/reducers/turnitin';
import { selectedContent } from '../redux/selectors';
import axios from 'axios';
import { setExamTime } from '../redux/reducers/userProgramsFull';
import { API_LINK, STATUSES } from '../constants';
import { contentItemSuccess } from "../redux/reducers/contentList";
import { logoutUserRequest } from '../redux/reducers/login';
const API = `${API_LINK}api/user`;
const NotificationFire = (props) => {
  const [notification, setNotification] = useState({title: '', body: ''});
  const notify = () =>  toast(<ToastDisplay/>,{
    duration: 4000,
    position: 'top-center'}); 
  function ToastDisplay() {
    return (
      <div style={{zIndex:100000000}}>
        <p><b>{notification?.title}</b></p>
        <p>{notification?.body}</p>
      </div>
    );
  };

  useEffect(() => {
    if (notification?.title ){
     notify()
    }
  }, [notification])
  
  if(props.login.user){
    requestForToken(props.login.user.userId);
  }

  const refreshItem = async(library_id)=>{
    var result =  await axios({
      method: 'get',
      url: `${API}/${props.login.user.userId}/getComponent?component_id=${library_id}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${props.login.token}`,
      },
    })
    props.contentItemSuccess(result.data.data.component[0].content[0])
  }
  

  onMessageListener((payload) => {
    if(payload?.notification?.title=='tii_report_complete'){
      var results = JSON.parse(payload?.notification?.body)
      if(results.overall_match_percentage>25 && results.submission_count<results.submission_allowance){
        props.setResults(JSON.parse(payload?.notification?.body))
        props.showTurnitinResults(true)
        axios({
          method: 'post',
          url: process.env.REACT_APP_MY_VAR+"/api/updateAssessmentStatus?request_id="+results.request_id+"&status=ready",
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin'
      })
      }
      if(payload?.notification?.title=='tii_report_finished'){
        var tmp = JSON.parse(payload?.notification?.body)
        refreshItem(tmp.library_id)
      }
      //   axios({
      //     method: 'post',
      //     url:  process.env.REACT_APP_MY_VAR+"/api/updateAssessmentStatus?request_id="+results.request_id+"&status=submit",
      //     headers: {
      //       'Access-Control-Allow-Origin': '*',
      //       'Content-Type': 'application/json',
      //       'X-Requested-With': 'XMLHttpRequest',
      //     },
      //     credentials: 'same-origin'
      // })
    //  }
    
     
    }
    if(payload?.notification?.title=='tii_submission_complete'){
      
      props.turnitinGenerateRequest()
     
    }
    if(payload?.notification?.title=='session_warning'){
      props.showLogoutModal(true)
    }
    if(payload?.notification?.title=='session_logout'){
      props.showLogoutModal(false)
      props.logout(true)
    }

    if(payload?.notification?.title=='exam_change'){
      setNotification({title:'Exam time changed', body: 'The exam now starts at '+JSON.parse(payload?.notification?.body).start_time+' and ends at '+JSON.parse(payload?.notification?.body).end_time});  
      requestForToken(props.login.user.userId);
      var tmp = JSON.parse(payload?.notification?.body)
      props.setExamTime(tmp)
      refreshItem(tmp.library_id)

    }

    if(payload?.notification?.title=='tii_submission'){
      var obj = JSON.parse(payload?.notification?.body)
      props.setRequestId(obj)

      if(obj.attempt<obj.submission_allowance && obj.overall_match_percentage==null){
      
        props.turnitinRequest()
      }else{
        // https://cpslearn.co.za/api/surveyStatus?user_id=776&survey_id=107&module_id=118&attempt=1&editable=1
       
      //   axios({
      //     method: 'post',
      //     url: process.env.REACT_APP_MY_VAR+"/api/surveyStatus?user_id="+props.login.user.userId+"&survey_id="+props.turnitin.selectedContent.survey_id+"&module_id="+props.turnitin.selectedContent.module_id+"&attempt="+(props.turnitin.selectedContent.attempts.length+1)+"&editable=1",
      //     headers: {
      //       'Access-Control-Allow-Origin': '*',
      //       'Content-Type': 'application/json',
      //       'X-Requested-With': 'XMLHttpRequest',
      //     },
      //     credentials: 'same-origin'
      // })
    }
    }
    //  requestForToken(props.login.user.userId);
  })

  return (
     <Toaster/>
  )
}

const mapStateToProps = state => ({
  login: state.loginReducer,
  turnitin: state.turnitinReducer
});
const mapDispatchToProps = dispatch => ({
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  setRequestId: value => dispatch(setRequestId(value)),
  turnitinEulaRequest: () => dispatch(turnitinEulaRequest()),
  turnitinRequest: () => dispatch(turnitinRequest()),
  showTurnitinResults: (bool) => dispatch(showTurnitinResults(bool)),
  showLogoutModal: (bool) => dispatch(showLogoutModal(bool)),
  logout: (bool) => dispatch(logoutUserRequest(bool)),
  setExamTime: (bool) => dispatch(setExamTime(bool)),
  contentItemSuccess: value => dispatch(contentItemSuccess(value)),
  turnitinGenerateRequest: () => dispatch(turnitinGenerateRequest())
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(NotificationFire);
